import React, { useEffect, useRef } from 'react';

const VideoTile = ({
  stream,
  label = 'Participant',
  isMuted = false,
  isCameraOff = false,
  isHost = false,
  isLocal = false,
  isScreenShare = false,
  handRaised = false,
  fill = false,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;
    el.srcObject = stream || null;
  }, [stream]);

  const showVideo = stream && !isCameraOff;
  const initial = (label || '?').charAt(0).toUpperCase();

  return (
    <div
      className={[
        'ls-tile',
        isHost ? 'ls-tile--host' : '',
        isLocal && !isScreenShare ? 'ls-tile--mirror' : '',
        isScreenShare ? 'ls-tile--screen' : '',
        fill ? 'ls-tile--fill' : '',
      ].filter(Boolean).join(' ')}
    >
      <video ref={videoRef} autoPlay playsInline muted={isLocal} style={{ display: showVideo ? 'block' : 'none' }} />
      {!showVideo && (
        <div className="ls-tile__ph">
          <div className="ls-avatar">{initial}</div>
        </div>
      )}
      {handRaised && <div className="ls-hand" aria-hidden>✋</div>}
      <div className="ls-tile__bar">
        <span className="ls-tile__name">
          {label}{isLocal ? ' (You)' : ''}
        </span>
        <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {isHost && <span className="ls-chip">HOST</span>}
          {isScreenShare && <span className="ls-chip">SHARE</span>}
          {isMuted && <span className="ls-mute" aria-label="Muted">✕</span>}
        </span>
      </div>
    </div>
  );
};

export default VideoTile;
